import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect (the reset-link
 * request), not a state transition (the saga owns the resulting `submit*`
 * transitions).
 */

/** Submit the current draft (dispatched when the user asks for a reset link). */
export const submitRequested = createAction('forgotPassword/submitRequested');
